module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Hand.6ebaa18a.woff";